import { useLDClient } from 'launchdarkly-react-client-sdk';
import { useEffect, useState } from 'react';
import { useDispatch } from '@shared/store';

export function useSetBusinessId(businessId: number) {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch({
      type: 'UPDATE_CURRENT_BUSINESS_ID',
      value: { businessId },
    });
  }, [businessId, dispatch]);
}

export function useInitLaunchDarkly(businessId: number) {
  const [identified, setIdentified] = useState(false);
  const ldClient = useLDClient();

  useEffect(() => {
    if (!ldClient || !businessId || identified) {
      return;
    }

    ldClient.identify({
      kind: 'multi',
      // Existing flag rules and segments target the org- key and businessId on the
      // user context, so that context stays as it was.
      user: {
        key: `org-${businessId}`,
        businessId,
      },
      business: {
        key: String(businessId),
      },
    });

    setIdentified(true);
  }, [ldClient, businessId, identified]);
}
